const getSubdomain = (url: string | undefined = undefined) => {
  if (!url) return defaultCheck();

  return customUrlCheck(url);
};

const defaultCheck = () => {
  if (process.env.NODE_ENV === "development") return "platform";

  return window.location.host.split(".")[0];
};

const customUrlCheck = (url: string) => {
  const regex = /https?:\/\/([a-zA-Z0-9-]+)(?:\.[a-zA-Z0-9-]+)*[:/]/;
  const match = url.match(regex);
  return match?.[1] || url.split(".")[0];
};

export default getSubdomain;
